export const sliderConfig = (slidesToShow, infinite, centerPadding, mobileArrow, mobileSlideToShow) => ({
  slidesToShow: slidesToShow,
  slidesToScroll: 1,
  centerPadding: centerPadding,
  infinite: infinite,
  responsive: [{
      breakpoint: 667,
      settings: {
        arrows: mobileArrow,
        centerMode: false,
        slidesToShow: mobileSlideToShow,
        swipe: true,
        dots: false,
      }
    },
    {
      breakpoint: 991.98,
      settings: {
        slidesToShow: mobileSlideToShow,
        infinite: true
      }
    }
  ]
});